export function getCurrentYear() {
  return +`1${new Date().getFullYear()}0101`;
}